import { useRouter } from 'next/router';
import { useTheme } from 'styled-components';

import imageResize from 'utils/imageResize';
import SocialActivityAction from 'components/SocialActivityAction';
import PostHeader from 'components/PostHeader';
import EmptyUserProfilePhoto from 'components/EmptyUserProfilePhoto/EmptyUserProfilePhoto';
import Link from 'components/common/Link';
import { routesPath } from 'utils/constants/routePath';
import { EmptyGroupIcon, LockIcon } from 'public/assets/icons';
import Image from 'components/common/Image';
import { regexMap } from 'utils/constants/regex';
import CollaboratorsSlider from 'containers/CollaboratorsSlider';
import { IProfileMembershipPost } from './IProfileMembershipPost';

import {
  CoverImg,
  EmptyUserPhoto,
  ProfilePostWrapper,
  GroupDescription,
  GroupDescriptionName,
  GroupHeaderWrap,
  GroupNamesWrap,
  MediaWrapper,
  WheelMarkIconWrap,
} from './ProfileMembershipPost.styles';

const ProfileMembershipPost = ({
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  isMe,
  followingStatus,
  postTime,
  isClickable,
  origin,
  id,
  originId,
  group,
  collaborators,
  privacy,
  onPinPress,
  data
}: IProfileMembershipPost) => {
  const router = useRouter();
  const theme: any = useTheme();

  const onPostClick = () => {
    const { origin: URLOrigin } = window.location;
    let url = URLOrigin;

    router.push(`${url}/g/${originId}`);
  };

  return (
    <ProfilePostWrapper>
      <PostHeader
        profilePhoto={profilePhoto}
        userId={userId}
        username={username}
        fullname={fullname}
        creatorId={creatorId}
        isVerified={isVerified}
        isAmbassador={isAmbassador}
        isDonor={isDonor}
        isMe={isMe}
        followingStatus={followingStatus}
        postTime={postTime}
        type={7}
        id={id}
        origin={origin}
        originId={originId}
        onPinPress={onPinPress}
        data={data}
      />
      <MediaWrapper isClickable={isClickable} onClick={onPostClick}>
        {regexMap.urlImg.test(group?.coverPhoto) ? (
          <Image
            src={imageResize(group?.coverPhoto) || group?.coverPhoto}
            alt="group cover photo"
            width={550}
            height={366}
            unoptimized
            priority
          />
        ) : (
          <CoverImg>
            <WheelMarkIconWrap>
              <Image
                src="/assets/img/tireTrace.png"
                alt="tire trace"
                width={550}
                height={366}
                unoptimized
                priority
              />
            </WheelMarkIconWrap>
          </CoverImg>
        )}
        <GroupHeaderWrap
          isClickable={isClickable}
          onClick={onPostClick}
          isCollaboratorsExists={collaborators?.length > 0}
        >
          <Link path={`${routesPath.group_details}/${originId}`}>
            {!group?.coverPhoto?.trim() ? (
              <Image
                src={
                  imageResize(group?.coverPhoto, '_thumb') || group?.coverPhoto
                }
                alt="group cover photo"
                height={48}
                width={48}
                unoptimized
                priority
              />
            ) : (
              <EmptyUserPhoto>
                <EmptyGroupIcon />
              </EmptyUserPhoto>
            )}
          </Link>

          <GroupNamesWrap>
            <Link path={`${routesPath.group_details}/${originId}`}>
              <GroupDescription>
                {group?.username}
                {privacy > 0 && !followingStatus && (
                  <LockIcon color={theme.colors.orange} />
                )}
              </GroupDescription>
            </Link>

            <GroupDescriptionName>{group?.name}</GroupDescriptionName>
          </GroupNamesWrap>
        </GroupHeaderWrap>
      </MediaWrapper>
      {collaborators?.length > 0 && (
        <CollaboratorsSlider collaborators={collaborators} />
      )}
    </ProfilePostWrapper>
  );
};

export default ProfileMembershipPost;
